export enum Kit {
    PGD = 0,
    PG_SEQ,
    RECEPTIVITY,
    INMUNOOCOMP,
    ALL
}

export const kitTitle = (): Record<Kit, string> => ({
    [Kit.PGD]: "pgd",
    [Kit.PG_SEQ]: "pgsec",
    [Kit.RECEPTIVITY]: "receptivity",
    [Kit.INMUNOOCOMP]: "immunocompatibility",
    [Kit.ALL]: "all"
})
